import { z } from "zod";
import { companySchema as c } from "@/schema/Company";

export const companySchema = c.extend({
    status: z.object({
        id: z.number(),
        name: z.string(),
        }),
    has_improvement_proposal: z.coerce.boolean(),  
}
);

export type Company = z.infer<typeof companySchema>;